<form [formGroup]="form" (keydown.enter)="$event.preventDefault()">
  <div class="esf-form-item"
       app-form-field-search
       [placeholder]="nameEmailCustomerNum"
       [id]="'search'"
       [control]="form.get('search')"
       (inputChanged)="searchCustomer($event.target.value, false)"
       (enterPressed)="searchCustomer($any($event.target).value, true)">
  </div>
</form>
